import {createContext, useEffect, useReducer, useRef} from 'react'
import {userReducer} from './reducers/userReducer'
import {IState, IUser, IUserContext} from './types/user'
import {useMutation} from '@apollo/client'
import {VERIFY_TOKEN} from '../graphql/mutations/loginMutation'
import {IVerifyToken} from '../graphql/types/loginTypes'

export const UserContext = createContext({} as IUserContext)

const initialUser: IState = {
  user: null,
  statusUser: 'checking',
  idOrganization: null,
}

export const UserProvider = ({children}: {children: React.ReactNode}) => {
  const [state, dispatch] = useReducer(userReducer, initialUser)
  const [gqlVerify, {data, loading, error}] = useMutation<IVerifyToken>(VERIFY_TOKEN)
  const render = useRef(0)
  const login = (user: IUser) => {
    localStorage.setItem('token', user.tokenAuth.token)
    localStorage.setItem('user', JSON.stringify(user))
    dispatch({
      type: 'login',
      paylaod: user,
    })
  }
  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('store')
    localStorage.clear()
    dispatch({
      type: 'logout',
    })
  }
  const updateOrganization = (id: string) => {
    dispatch({type: 'updateOrganization', payload: id})
  }
  useEffect(() => {
    const token = window.localStorage.getItem('token')
    if (!token) {
      return dispatch({type: 'logout'})
    }

    if (render.current === 0) {
      render.current = 1
      gqlVerify({
        variables: {
          token,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (loading) {
      dispatch({
        type: 'checking',
      })
    }
  }, [loading])

  useEffect(() => {
    if (data) {
      if (data.verifyToken && data.verifyToken.payload) {
        const date = data.verifyToken.payload.exp

        const fechaActual = Date.now()

        // Obtiene la fecha de vencimiento del token en milisegundos (suponiendo que el valor proporcionado es en segundos)
        const fechaVencimientoToken = date * 1000

        // Calcula la diferencia en milisegundos entre la fecha de vencimiento y la fecha actual
        const diferencia = fechaVencimientoToken - fechaActual

        // Convierte la diferencia en minutos
        const minutosRestantes = Math.floor(diferencia / (1000 * 60))

        if (minutosRestantes <= 30) {
          return logout()
        }
        const strUser = localStorage.getItem('user')
        if (!strUser) return logout()
        const userObj = JSON.parse(strUser) as IUser
        dispatch({
          type: 'login',
          paylaod: userObj,
        })
      } else {
        logout()
      }
    }
  }, [data])

  useEffect(() => {
    if (error) {
      console.log('error', error)
      logout()

      window.localStorage.removeItem('token')
      window.localStorage.removeItem('user')
    }
  }, [error])
  return (
    <UserContext.Provider value={{...state, login, logout, updateOrganization}}>
      {children}
    </UserContext.Provider>
  )
}
